__turbopack_context__.v({
  "compact": "SocialMediaLinks-module-scss-module__fUs9MW__compact",
  "container": "SocialMediaLinks-module-scss-module__fUs9MW__container",
  "socialLink": "SocialMediaLinks-module-scss-module__fUs9MW__socialLink",
  "socialLinks": "SocialMediaLinks-module-scss-module__fUs9MW__socialLinks",
});
